export const MAILROOM_BATCH_FILTER = {
    APPLIED_FILTER_SEARCH_LABEL: { key: "APPLIED_FILTER_SEARCH_LABEL", value: 'SEARCH' },
    SEARCH_PLACEHOLDER: { key: "SEARCH_PLACEHOLDER", value: 'Search' },
    DATE_RANGE_LABEL: { key: "DATE_RANGE_LABEL", value: 'DATE RANGE' },
    APPLIED_FILTER_DATE_RANGE_LABEL: { key: "APPLIED_FILTER_DATE_RANGE_LABEL", value: 'From Date' },
    RANGEPICKER_TO_PLACEHOLDER: { key: "RANGEPICKER_TO_PLACEHOLDER", value: 'To Date' },
    CLOSE_ADVANCED_SEARCH_TOOLTIP: { key: "CLOSE_ADVANCED_SEARCH_TOOLTIP", value: 'Close Advanced Search' },
    ADVANCED_SEARCH_TOOLTIP: { key: "ADVANCED_SEARCH_TOOLTIP", value: 'Advanced Search' },
};

export const PRINT_FAILURE_TABLE = {
    PRINT_FAILURES_TABLE_TITLE: { key: "PRINT_FAILURES_TABLE_TITLE", value: 'Print Failures' },
    TOTAL_DOCMENTS: { key: "TOTAL_DOCMENTS", value: 'Selected {{page}} pages from {{document}} documents' },
    SELECT_PRINTER_PLACEHOLDER: { key: "SELECT_PRINTER_PLACEHOLDER", value: 'Select a Printer' },
    RE_PRINT_BUTTON: { key: "RE_PRINT_BUTTON", value: 'Re-Print' },
    REFRESH_ACTION: { key: "REFRESH_ACTION", value: 'Refresh' },
    PRINTING_LOADING_MESSAGE: { key: "PRINTING_LOADING_MESSAGE", value: 'Printing' },
    SOMETHING_WRONG_ERROR_MESSAGE: { key: "SOMETHING_WRONG_ERROR_MESSAGE", value: 'Oops! Something went wrong' },
    REPRINT_INITIATED_SUCCESS_MESSAGE: { key: "REPRINT_INITIATED_SUCCESS_MESSAGE", value: 'Re-Print Initiated Successfully!!!' },
    SELECT_PRINTER_POPUP_TITLE:{ key: "SELECT_PRINTER_POPUP_TITLE", value: 'Select a Printer' },
};

export const BATCH_APPLIED_FILTER = {
    APPLIED_FILTER_TITLE: { key: "APPLIED_FILTER_TITLE", value: 'Applied Filters' },
    FROM_DATE_LABEL: { key: "FROM_DATE_LABEL", value: 'From Date' },
    TO_DATE_LABEL: { key: "TO_DATE_LABEL", value: 'To Date' },
    SELECT_PRINTER_LABEL: { key: "SELECT_PRINTER_LABEL", value: 'Selected Printer' },
    SEARCH_LABEL: { key: "SEARCH_LABEL", value: 'Search' },
    NUMBER_OF_FILES_LABEL: { key: "NUMBER_OF_FILES_LABEL", value: 'Number of Files' },
    TAG_LABEL: { key: "TAG_LABEL", value: 'Tag' },
    PAGES_LABEL: { key: "PAGES_LABEL", value: "Pages"}
};

export const BATCH_LIST = {
    MAIL_ROOM_TITLE: { key: "MAIL_ROOM_TITLE", value: 'Mail Room' },
    CREATE_NEW_PRINT_TITLE: { key: "CREATE_NEW_PRINT_TITLE", value: 'Create a new print job' },
    CREATE_BATCH_DESCRIPTION: { key: "CREATE_BATCH_DESCRIPTION", value: 'Select documents to initiate a print job' },
    CREATE_NEW_BUTTON: { key: "CREATE_NEW_BUTTON", value: 'Create new' },
    FILES_LABEL: { key: "FILES_LABEL", value: 'Files' },
    PRINTER_LABEL: { key: "PRINTER_LABEL", value: 'Printer' },
    PRINTED_LABEL: { key: "PRINTED_LABEL", value: 'Printed' },
    QUEUE_LABEL: { key: "QUEUE_LABEL", value: 'In Queue' },
    FAILED_LABEL: { key: "FAILED_LABEL", value: 'Failed' },
    APPLIED_FILTER_BUTTON: { key: "APPLIED_FILTER_BUTTON", value: 'Applied Filters' },
    APPLIED_FILTER_TABLE_HEADER: { key: "APPLIED_FILTER_TABLE_HEADER", value: 'Applied Filters' },
    APPLIED_FILTER_SEARCH_LABEL: { key: "APPLIED_FILTER_SEARCH_LABEL", value: 'Search' },
    APPLIED_FILTER_TAGS_LABEL: { key: "APPLIED_FILTER_TAGS_LABEL", value: 'Tags' },
    APPLIED_FILTER_DATE_RANGE_LABEL: { key: "APPLIED_FILTER_DATE_RANGE_LABEL", value: 'Date Range' },
    APPLIED_FILTER_DATE_TO: { key: "APPLIED_FILTER_DATE_TO", value: 'to' },
    LOADING: { key: "LOADING", value: 'Loading more...' },
    NO_BATCH_MESSAGE: { key: "NO_BATCH_MESSAGE", value: 'No Batches found' },
    GOT_ALL_RESULT_MESSAGE: { key: "GOT_ALL_RESULT_MESSAGE", value: 'You have got all results' },
    BATCH_FILTER_TITLE: { key: "BATCH_FILTER_TITLE", value: 'Batch Filter' },
    NO_DOCUMENT_AVAILABLE_DESCRIPTION: { key: "NO_DOCUMENT_AVAILABLE_DESCRIPTION", value: 'No documents available!' },
};

export const FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP = {
    BATCH_NAME_PLACEHOLDER: { key: "BATCH_NAME_PLACEHOLDER", value: 'Batch Name' },
    BATCH_DESCRIPTION_PLACEHOLDER: { key: "BATCH_DESCRIPTION_PLACEHOLDER", value: 'Give a short description about batch' },
    SEARCH_PRINTERS_PLACEHOLDER: { key: "SEARCH_PRINTERS_PLACEHOLDER", value: 'Search Printers' },
    NUMBER_OF_DOCUMENTS_LABEL: { key: "NUMBER_OF_DOCUMENTS_LABEL", value: 'Total Number of Documents' },
    NUMBER_OF_PAGES_LABEL: { key: "NUMBER_OF_PAGES_LABEL", value: 'Total Number of Pages' },
    FILTER_DOCUMENT_TITLE: { key: "FILTER_DOCUMENT_TITLE", value: 'Filter Documents' },
    FILTER_DESCRIPTION: { key: "FILTER_DESCRIPTION", value: 'Filter documents for Print' },
    INITIATE_PRINT_TITLE: { key: "INITIATE_PRINT_TITLE", value: 'Initiate Print Job' },
    INITIATE_PRINT_DESCRIPTION: { key: "INITIATE_PRINT_DESCRIPTION", value: 'Select the printer and initiate the Print job' },
    NEXT_BUTTON: { key: "NEXT_BUTTON", value: 'Next' },
    PREVIEW_BUTTON: { key: "PREVIEW_BUTTON", value: 'Previous' },
    PRINT_LOADING: { key: "PRINT_LOADING", value: 'Printing' },
    PRINT_BUTTON: { key: "PRINT_BUTTON", value: 'Print' },
    UNABLE_TO_CREATE_ERROR_MESSAGE: { key: "UNABLE_TO_CREATE_ERROR_MESSAGE", value: 'Unable to create batch' },
    BATCH_CREATED_SUCCESS_MESSAGE: { key: "BATCH_CREATED_SUCCESS_MESSAGE", value: 'Batch {{batchName}} Created Successfully!' },
    UNAVAILABLE_DOCUMENTS_ERROR_MESSAGE: { key: "UNAVAILABLE_DOCUMENTS_ERROR_MESSAGE", value: 'No documents available!' },
    PRINTER_NOT_SELECTED_ERROR_MESSAGE: { key: "PRINTER_NOT_SELECTED_ERROR_MESSAGE", value: 'Please select a printer!' },
};

export const BATCHLIST_DATA_TABLE = {
    STATUS_COLUMN_NAME: { key: "STATUS_COLUMN_NAME", value: 'Status' },
    PRINT_DROPDOWN_OPTION: { key: "PRINT_DROPDOWN_OPTION", value: 'Printed' },
    QUEUE_DROPDOWN_OPTION: { key: "QUEUE_DROPDOWN_OPTION", value: 'In Queue' },
    FAILED_DROPDOWN_OPTION: { key: "FAILED_DROPDOWN_OPTION", value: 'Failed' },
    BATCH_COLUMN_NAME: { key: "BATCH_COLUMN_NAME", value: 'Batch Name' },
    DOCUMENT_COLUMN_NAME: { key: "DOCUMENT_COLUMN_NAME", value: 'Document Name' },
    FAILURE_REASON_COLUMN_NAME: { key: "FAILURE_REASON_COLUMN_NAME", value: 'Failure Reason' },
    FAILED_ON_COLUMN_NAME: { key: "FAILED_ON_COLUMN_NAME", value: 'Failed On' },
    PRINT_COLUMN_NAME: { key: "PRINT_COLUMN_NAME", value: 'Printed/Failed On' },
    PAGE_COLUMN_NAME: { key: "PAGE_COLUMN_NAME", value: 'Pages' },
    BATCH_NAME_PLACEHOLDER: { key: "BATCH_NAME_PLACEHOLDER", value: 'Batch Name' },
    DOCUMENT_NAME_PLACEHOLDER: { key: "DOCUMENT_NAME_PLACEHOLDER", value: 'Document Name' },
    TAG_PLACEHOLDER: { key: "TAG_PLACEHOLDER", value: 'Tag' },
    PAGES_PLACEHOLDER: { key: "PAGES_PLACEHOLDER", value: "Pages" },
    CLEAR_BUTTON: { key: "CLEAR_BUTTON", value: 'Clear' },
    SEARCH_BUTTON: { key: "SEARCH_BUTTON", value: 'Search' },
    RANGE_LIMIT_ERROR: { key: "RANGE_LIMIT_ERROR", value: 'Kindly input a number within the range of 0 to 100.' },
};

export const DELETE_DOCUMENT_MODAL = {
    DOCUMENT_DELETED_SUCCESS_MESSAGE: { key: "DOCUMENT_DELETED_SUCCESS_MESSAGE", value: 'Documents deleted successfully!' },
    DELETE_DOCUMENT_TITLE: { key: 'DELETE_DOCUMENT_TITLE', value: "Delete Documents" },
    SELECT_ALL_DOCUMENTS_CHECKBOX_LABEL: { key: 'SELECT_ALL_DOCUMENTS_CHECKBOX_LABEL', value: "Select All Documents" },
    DELETE_CONFIRMATION_MESSAGE: { key: "DELETE_CONFIRMATION_MESSAGE", value: 'Are you sure you want to delete {{Count}} document' },
    DELETE_BUTTON: { key: "DELETE_BUTTON", value: 'Delete' },
    DELETE_DOCUMENT_BUTTON: { key: "DELETE_DOCUMENT_BUTTON", value: 'Delete {{Count}} document' },
    SELECT_A_DOCUMENT_WARNING_MESSAGE: { key: "SELECT_A_DOCUMENT_WARNING_MESSAGE", value: 'Please select a document to delete!' },
};

export const MAIL_ROOM_DOCUMENT_FILTERS = {
    SEARCH_DOCUMENT_PLACEHOLDER: { key: "SEARCH_DOCUMENT_PLACEHOLDER", value: 'Search documents' },
    TAG_FILTER_PLACEHOLDER: { key: "TAG_FILTER_PLACEHOLDER", value: 'Tag Filter' },
    SELECT_TAG_PLACEHOLDER: { key: "SELECT_TAG_PLACEHOLDER", value: 'Search for tags to select' },
    DATE_TIME_PICKER_FROM_LABEL: { key: "DATE_TIME_PICKER_FROM_LABEL", value: 'From' },
    DATE_TIME_PICKER_TO_LABEL: { key: "DATE_TIME_PICKER_TO_LABEL", value: 'To' },
    RANGE_LIMIT_ERROR: { key: "RANGE_LIMIT_ERROR", value: 'Kindly input a number within the range of 0 to 100.' },
    PAGES_LABEL: { key: "PAGES_LABEL", value: 'Pages:' },
};

export const MAIL_ROOM_PRINTER_LIST = {
    NO_PRINTER_AVAILABLE_DESCRIPTION: { key: "NO_PRINTER_AVAILABLE_DESCRIPTION", value: 'No printers available' },
};

export const FAILURE_COUNT_AND_DELETE_DOCUMENTS_CARDS = {
    DELETE_DOCUMENT_BUTTON: { key: "DELETE_DOCUMENT_BUTTON", value: 'Delete Documents' },
    DELETE_DOCUMENT_TOOLTIP: { key: "DELETE_DOCUMENT_TOOLTIP", value: 'Delete documents from mail room' },
    FAILURES_LABEL: { key: "FAILURES_LABEL", value: 'Failures' },
    REFRESH_ACTION: { key: "REFRESH_ACTION", value: 'Refresh' },
    LAST_UPDATED_ON_LABEL: { key: "LAST_UPDATED_ON_LABEL", value: 'Last updated on' },
};

